import React from 'react';
import PropTypes from 'prop-types';
import { ArrowBack } from '@one-thd/sui-icons';
import {
  ListItem,
  ListItemButton,
  ListItemText
} from '@one-thd/sui-atomic-components';
import { NestedLinkRefinement } from './NestedLinkRefinement';

const LinkRefinement = ({
  arrow,
  dimension,
  id,
  onChange,
  refinement,
  hasBoldStyle,
  isBreadCrumbPresent = false
}) => {

  const handleRefinementSelect = (event) => {
    event.preventDefault();
    if (onChange) {
      onChange({ refinement, dimension });
    }
  };

  return (
    <>
      {/* SEO-friendly hidden link - Required for SEO significance. Reach out to SEO team if wanting to change */}
      <a
        href={refinement.url}
        className="sui-hidden"
        aria-hidden="true"
        tabIndex="-1"
      >
        {/* H3 element required for SEO significance. Reach out to SEO team if wanting to change */}
        <h3>{refinement.label}</h3>
      </a>
      <ListItem
        id={id}
        data-refinement={refinement.label}
        data-filterposition="left rail:top filters:1"
        data-active="yes"
        data-omni="true"
      >
        <ListItemButton
          data-testid={arrow ? `breadcrumb-${refinement.label}-${id}` : `category-refinement-${refinement.label}-${id}`}
          disableGutters={!isBreadCrumbPresent}
          aria-label={`Filter by ${refinement.label}`}
          data-refinementvalue={refinement.label}
          onClick={(event) => handleRefinementSelect(event)}
        >
          {arrow && (
            <div className="sui-mt-1 sui-mr-2">
              <ArrowBack size="small" color="primary" />
            </div>
          )}
          <ListItemText
            primary={refinement.label}
            primaryTypographyProps={{
              weight: hasBoldStyle ? 'bold' : 'regular'
            }}
          />
        </ListItemButton>
      </ListItem>
      { refinement?.nestedRefinements?.length > 0 && (
        <NestedLinkRefinement
          id={id}
          dimension={dimension}
          refinement={refinement}
        />
      )}
    </>
  );
};

LinkRefinement.propTypes = {
  arrow: PropTypes.bool,
  dimension: PropTypes.shape({
    nestedRefinementsLimit: PropTypes.number.isRequired
  }).isRequired,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  refinement: PropTypes.shape({
    label: PropTypes.string,
    refinementKey: PropTypes.string,
    selected: PropTypes.bool,
    nestedRefinements: PropTypes.arrayOf(
      PropTypes.shape({
        length: PropTypes.number
      })
    ),
    url: PropTypes.string
  }).isRequired,
  hasBoldStyle: PropTypes.bool
};

LinkRefinement.defaultProps = {
  arrow: false,
  id: null,
  hasBoldStyle: false
};

LinkRefinement.displayName = 'LinkRefinement';

export { LinkRefinement };